// if a form is attempted to be submitted, set a class on it .submitted, however, if a form is invalid, no actual submission is attempted, as it is prevented by the browser, capture clicks on submit button and enters inside formfields instead
document.querySelectorAll('form').forEach(form => {
    form.addEventListener('submit', e => {
        form.classList.add('submitted');
    });
    form.addEventListener('click', e => {
        if(e.target.type === 'submit'){
            form.classList.add('submitted');
        }
    });
    form.addEventListener('keyup', e => {
        if(
            (
                e.target.type === 'input' || 
                e.target.type === 'select'
            ) && 
            e.key === 'Enter'
        ){
            form.classList.add('submitted');
        }
    });
});